import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/images/logo.webp';

function Footer({ showInstallButton, onInstallClick }) {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-content">
        {/* Colonne 1: Marque & Slogan (inchangée) */}
        <div className="footer-column about">
          <Link to="/" className="footer-logo-link">
            <img src={logo} alt="Logo Couleur Sirène" className="footer-logo" />
            <h4>Couleur Sirène</h4>
          </Link>
          <p className="footer-slogan">La magie de l'océan dans des créations uniques.</p>
        </div>

        {/* Colonne 2: Navigation (inchangée) */}
        <div className="footer-column links">
          <h4>Plan du site</h4>
          <ul>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/a-propos">À Propos</Link></li>
            <li><Link to="/catalogue">Catalogue</Link></li>
            <li><Link to="/agenda">Agenda</Link></li>
            <li><Link to="/galerie">Galerie</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* MODIFIÉ : Colonne 3: Contact avec icônes */}
        <div className="footer-column contact-info">
          <h4>Nous contacter</h4>
          <div className="contact-item">
            <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
            <span>
              101 impasse rançon,<br/>32130 POLASTRON
            </span>
          </div>
          <div className="contact-item">
            <svg viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
            <a href="tel:+33668150574">06 68 15 05 74</a>
          </div>
          <div className="contact-item">
            <svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
            <a href="mailto:couleursirene@gmail.com">couleursirene@gmail.com</a>
          </div>
        </div>

        {/* Colonne 4: Réseaux Sociaux (inchangée) */}
        <div className="footer-column social">
          <h4>Suivez-nous</h4>
          <div className="social-icons">
            <a href="https://www.instagram.com/couleur_sirene/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24"><path d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.2,5.2 0 0,1 16.2,21.4H7.8C4.6,21.4 2,18.8 2,15.6V7.8C2,4.6 4.6,2 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" /></svg>
            </a>
            <a href="https://www.facebook.com/people/Couleur-Sirène/100075524093868/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg viewBox="0 0 24 24"><path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.81C10.44 7.31 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z" /></svg>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        {/* Bouton d'installation PWA */}
        {showInstallButton && (
          <div className="footer-install-section">
            <button className="install-btn" onClick={onInstallClick}>
              📲 Installer l'application
            </button>
          </div>
        )}
        
        <div className="footer-legal-links">
          <Link to="/mentions-legales">Mentions Légales</Link>
          <Link to="/politique-de-confidentialite">Politique de Confidentialité</Link>
          <Link to="/cgv">CGV</Link>
        </div>
        <p>&copy; {currentYear} Couleur Sirène. Tous droits réservés.</p>
        <p className="footer-credit">
          Site propulsé par <a href="https://www.superbotboys.com/" target="_blank" rel="noopener noreferrer">SuperBotBoys</a> et <a href="https://www.infocolab.com/" target="_blank" rel="noopener noreferrer">InfoColab</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;